// Флаг "онбординг редактора маршрутов больше не показывать" - в localStorage.
// storage передаётся параметром (в тестах - подставной): доступ к
// localStorage может бросать (приватное окно, заблокированные данные сайта),
// тогда онбординг просто показывается каждый раз, а ошибки не всплывают.
const KEY = "ecoway.routeEditor.onboardingDismissed";

type StorageLike = Pick<Storage, "getItem" | "setItem">;

const defaultStorage = (): StorageLike | null => {
  try {
    return typeof localStorage === "undefined" ? null : localStorage;
  } catch {
    return null;
  }
};

export const isOnboardingDismissed = (storage: StorageLike | null = defaultStorage()): boolean => {
  try {
    return storage?.getItem(KEY) === "1";
  } catch {
    return false;
  }
};

export const dismissOnboarding = (storage: StorageLike | null = defaultStorage()): void => {
  try {
    storage?.setItem(KEY, "1");
  } catch {
    // без хранилища флаг просто не запоминается
  }
};
